import { Observable, map } from 'rxjs'

const isShallowEqual = (a: Record<string, unknown>, b: Record<string, unknown>): boolean => {
  const keys = Object.keys(a)
  return keys.length === Object.keys(b).length && keys.every((key) => a[key] === b[key])
}

// A projection that rebuilds its object every emission defeats the identity gate behind it, so the
// consumer re-renders for writes that changed none of the projected fields. Hand back the previous
// object when the fields match and the gate holds again.
export const stableProjection =
  <S, T extends Record<string, unknown>>(project: (source: S) => T) =>
  (source$: Observable<S>): Observable<T> => {
    let last: T | undefined
    return source$.pipe(
      map((value) => {
        const next = project(value)
        last = last && isShallowEqual(last, next) ? last : next
        return last
      })
    )
  }
